import {grey400, grey600} from 'material-ui/styles/colors';

const styles = {
    label: {
        color: grey600,
        lineHeight: '1em',
        marginBottom: '5px'
    },
    text: {
        lineHeight: '1em',
        marginTop: '15px',
        marginBottom: '10px'
    },
    emptytext: {
        color: grey400,
        lineHeight: '1em',
        marginTop: '15px',
        marginBottom: '10px'
    }
};

export default styles;



// WEBPACK FOOTER //
// src/components/common/Info/Info.css.js